import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QRCodeComponent } from './qr-code/qr-code.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [QRCodeComponent],
  imports: [
    CommonModule,
    MatToolbarModule,
    ZXingScannerModule,
    MatButtonToggleModule,
    TranslateModule,
    MatSlideToggleModule,
    MatIconModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule,
  ],
  exports: [QRCodeComponent],
})
export class ScanModule {}
